import React from "react";
import {
  Box,
  Button,
  Checkbox,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";
import { PRODUCT_TYPE_IF_OPTIONS } from "./data";

/**
 * Multi-select product type picker (Indica / Sativa / Hybrid).
 * Used on category_and_brand → chained product type in product IF rules.
 */
export default function ProductTypeList({
  changeHandler = () => {},
  inputValue = [],
  setOpen,
}) {
  const selectedValues = Array.isArray(inputValue)
    ? inputValue
    : inputValue != null && inputValue !== ""
      ? PRODUCT_TYPE_IF_OPTIONS.filter((o) => o.value === inputValue)
      : [];

  const handleToggle = (option) => {
    const idx = selectedValues.findIndex((item) => item.value === option.value);
    const next = [...selectedValues];
    if (idx === -1) {
      next.push(option);
    } else {
      next.splice(idx, 1);
    }
    changeHandler({ ruleValue: next });
  };

  const allSelected =
    PRODUCT_TYPE_IF_OPTIONS.length > 0 &&
    PRODUCT_TYPE_IF_OPTIONS.every((opt) =>
      selectedValues.some((item) => item.value === opt.value)
    );

  const handleSelectAll = () => {
    changeHandler({
      ruleValue: allSelected ? [] : [...PRODUCT_TYPE_IF_OPTIONS],
    });
  };

  return (
    <Box sx={{ p: 2, minWidth: 220 }} onClick={(e) => e.stopPropagation()}>
      {/* <Typography variant="subtitle2" sx={{ fontWeight: "bold", color: "#333", mb: 1 }}>
        Product type (multi-select)
      </Typography> */}

      {/* <ListItem disablePadding sx={{ mb: 0.5 }}>
        <ListItemButton onClick={handleSelectAll} sx={{ py: 0.5, borderRadius: 1 }}>
          <Checkbox checked={allSelected} size="small" disableRipple sx={{ p: 0, mr: 0 }} />
          <ListItemText
            primary={<Typography variant="body2" fontWeight={600}>Select all</Typography>}
          />
        </ListItemButton>
      </ListItem> */}

      <Box sx={{ maxHeight: 220, overflow: "auto", mb: 2 }}>
        {PRODUCT_TYPE_IF_OPTIONS.map((option) => {
          const isChecked = selectedValues.some((item) => item.value === option.value);
          return (
            <ListItem key={option.value} disablePadding sx={{ mb: 0.2 }}>
              <ListItemButton
                onClick={() => handleToggle(option)}
                selected={isChecked}
                sx={{ py: 0.5, borderRadius: 1 }}
              >
                <Checkbox
                  checked={isChecked}
                  edge="start"
                  disableRipple
                  size="small"
                  sx={{ p: 0.5, mr: 1 }}
                />
                <ListItemText
                  primary={
                    <Typography
                      variant="body2"
                      fontWeight={isChecked ? "bold" : "normal"}
                      color={isChecked ? "primary.main" : "#444"}
                    >
                      {option.title}
                    </Typography>
                  }
                />
              </ListItemButton>
            </ListItem>
          );
        })}
      </Box>

      
    </Box>
  );
}
